import { Component, OnInit, ViewChild, TemplateRef, inject } from '@angular/core';
import { DatatableColumn } from 'projects/bis-shared/src/lib/datatable/datatable-column';
import { DatatableSort } from 'projects/bis-shared/src/lib/datatable/datatable-sort';
import { DatatableComponent } from 'projects/bis-shared/src/lib/datatable/datatable/datatable.component';
import { DatatableStaticTemplateType } from 'projects/bis-shared/src/lib/datatable/datatable-static-template';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';
import { RelatedDocument } from 'projects/bis-shared/src/lib/document-shared/document.types';
import { SnackbarService } from 'projects/bis-shared/src/lib/snackbar/snackbar.service';
import { DocumentService } from '../../document/document.service';
import { ExternalApiUrls } from 'projects/bis-shared/src/lib/utility/apiurls-external';
import { Router, RouterModule } from '@angular/router';
import { FilingSubmissionStatus } from 'projects/bis-shared/src/lib/utility/filing-constants';
import { FilterDataType } from 'projects/bis-shared/src/lib/datatable/datatable-filter/filter-operations';
import { ObjectTypeCode } from 'projects/bis-shared/src/lib/utility/system-type-constants';
import { CommonModule } from '@angular/common';
import { DatatableModule } from 'projects/bis-shared/src/lib/datatable/datatable.module';
import { MaterialModule } from 'projects/bis-shared/src/lib/material/material.module';

@Component({
  selector: 'app-submitted-eforms-queue',
  templateUrl: './submitted-eforms-queue.component.html',
  styleUrls: ['./submitted-eforms-queue.component.scss'],
  imports: [
    DatatableModule,
    CommonModule,
    RouterModule,
    MaterialModule,
  ],
})
export class SubmittedEformsQueueComponent implements OnInit {
  private externalApiUrls = inject(ExternalApiUrls);
  private snackbarService = inject(SnackbarService);
  private docService = inject(DocumentService);
  private router = inject(Router);

  @ViewChild(DatatableComponent, { static: true }) datatable: DatatableComponent;
  @ViewChild('confirmationNumberTemplate', { static: true })
    confirmationNumberTemplate: TemplateRef<any>;
  @ViewChild('associatedWithTemplate', { static: true }) associatedWithTemplate: TemplateRef<any>;

  columns: DatatableColumn[];
  defaultSort: DatatableSort[];
  dataUrl: string;
  AppUrls = AppUrls;
  processingStatus = FilingSubmissionStatus.Processing;
  documentTypeCode = ObjectTypeCode;

  
 

  constructor() {
    this.defaultSort = [
      {
        property: 'submittedDate',
        sortAscending: false,
      },
      {
        property: 'relatedObjectTypeCode',
        sortAscending: false,
      },
      {
        property: 'relatedObjectId',
        sortAscending: false,
      },
    ];
  }

  ngOnInit(): void {
    this.columns = this.getDatatableColumns();
    this.dataUrl = this.externalApiUrls.filing.searchSubmittedEforms();
    this.datatable.emptyMessage = 'There are no submitted eForms to display.';
  }

  getDatatableColumns(): DatatableColumn[] {
    return [
      {
        title: 'eForm Document',
        property: 'confirmationNumber',
        filterDataType: FilterDataType.String,
        template: this.confirmationNumberTemplate,
      },
      {
        title: 'eForm Name',
        property: 'formType',
        filterDataType: FilterDataType.String,
        width: 400,
      },
      {
        title: 'Patient Name',
        property: 'patient',
        filterDataType: FilterDataType.String,
      },
      {
        title: 'Patient DOB',
        property: 'dateOfBirth',
        filterDataType: FilterDataType.Date,
        template: DatatableStaticTemplateType.UtcDateTemplate,
      },
      {
        title: 'WCB Case #',
        property: 'wcbCaseNumber',
        filterDataType: FilterDataType.String,
        template: DatatableStaticTemplateType.CaseNumberTemplate,
      },
      {
        title: 'eForm Details',
        property: 'relatedObjectIdFormatted',
        filterDataType: FilterDataType.SystemId,
        filterSystemIdColumnNames: { typeCode: 'relatedObjectTypeCode', id: 'relatedObjectId' },
        template: this.associatedWithTemplate,
      },
      {
        title: 'For',
        property: 'submitOnBehalfOfEntityName',
        filterDataType: FilterDataType.String,
      },
      {
        title: 'Submitted Date',
        property: 'submittedDate',
        filterDataType: FilterDataType.DateTime,
        template: DatatableStaticTemplateType.EasternDateTemplate,
      },
      {
        title: 'Status',
        property: 'filingSubmissionStatus',
        filterDataType: FilterDataType.Reference,
      },
    ];
  }

  printDocument(document: RelatedDocument) {
    this.docService.print(document.documentId);
  }

  downloadDocument(document: RelatedDocument) {
    this.snackbarService.openSnackBarSuccess(
      'Documents Downloading... Your download is being prepared. It will automatically download when ready.',
    );
    this.docService.download(document.documentId);
  }
}
